const configuredBaseUrl = (process.env.REACT_APP_API_BASE_URL || 'http://localhost:5000/api').replace(/\/+$/, '');

function resolveApiBaseUrl() {
  if (process.env.NODE_ENV !== 'development' || typeof window === 'undefined') {
    return configuredBaseUrl;
  }

  try {
    const backend = new URL(configuredBaseUrl);
    const frontend = new URL(window.location.href);
    const isLocalHost = (host) => ['localhost', '127.0.0.1'].includes(host);
    // Only proxy local -> local development. Remote backends keep their URL.
    if (isLocalHost(frontend.hostname) && isLocalHost(backend.hostname) && backend.port === '5000') {
      return backend.pathname.replace(/\/+$/, '') || '/api';
    }
  } catch {
    // Relative base URL, or an invalid URL; let Axios handle it normally.
  }
  return configuredBaseUrl;
}

export const API_BASE_URL = resolveApiBaseUrl();
// localStorage me sirf ye 4 keys rehti hain
export const TOKEN_KEY = 'accessToken';
export const REFRESH_TOKEN_KEY = 'refreshToken';
export const USER_KEY = 'userId';
export const WALLET_KEY = 'wallet';
// is app ki purani keys (login ke time saaf ho jati hain)
export const LEGACY_KEYS = ['roulette_access_token', 'roulette_refresh_token', 'roulette_user', 'rouletteHistory'];
